module.exports = __webpack_public_path__ + "media/customizations/jordanranch/logo-05f346f299bd0364f743a06600430154.png";